// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { AccountAddress } from './account-address';
import { ShippingUserGroup } from './shipping-user-group';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ShippingUserGroupAddressMap extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key FK shippingAccountAddress */
  shippingAccountAddressId!: string;
  /** Guid key FK shippingUserGroup */
  shippingUserGroupId!: string;
  /** FK shippingAccountAddressId */
  shippingAccountAddress!: AccountAddress;
  /** FK shippingUserGroupId */
  shippingUserGroup!: ShippingUserGroup;
}

